import { FETCH_USER_DETAILS } from './constants';

export const fetchUserDetailsAction = () => ({
    type: FETCH_USER_DETAILS
});
